import { useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import LocalStorage from 'utils/bom-dom-manipulation/local-storage';
import SpringConfigs from 'utils/constants/swarm/spring-configs';
import { storageKeyName } from 'utils/generic/storage-key-name';
import { ProfileData } from 'interfaces/authentication';
import { useAccountLogout } from 'hooks/auth/useAccountLogout';
import { useFetchAccountParams } from 'newhooks/account/useFetchAccountParams';
import { setPendingSuperBets, updateUserData } from 'store/actions';
import { updateOpenBets } from 'store/actions/betslip';

type TArgs = {
  updateUser: (userData: ProfileData) => void;
};

export const useUpdateUser = (): TArgs => {
  const dispatch = useDispatch();
  const { accountParams } = useFetchAccountParams();
  const accountLogout = useAccountLogout();

  const updateUser = useCallback(
    (userData: ProfileData) => {
      const switchMultiAccount = LocalStorage.getItem(
        storageKeyName('account', 'SWITCH_MULTI_ACCOUNT')
      );

      LocalStorage.removeItem(
        storageKeyName('account', 'SWITCH_MULTI_ACCOUNT')
      );

      if (userData) {
        if (userData.logout && !JSON.parse(switchMultiAccount)) {
          if (
            +accountParams?.singleSignIn ||
            SpringConfigs.IS_MULTI_ACCOUNT_DISABLED
          ) {
            accountLogout(true);
          }
        } else {
          dispatch(updateUserData(userData));

          if (userData.super_bet) {
            dispatch(setPendingSuperBets(userData.super_bet));
            dispatch(updateOpenBets());
          }
        }
      }
    },
    [accountParams?.singleSignIn]
  );

  const result = useMemo(
    () => ({
      updateUser
    }),
    [updateUser]
  );

  return result;
};
